// removed by extract-text-webpack-plugin
module.exports = {"startShoppingBtn":"startShoppingBtn__3Yhah","startShoppingUserStatusBtn":"startShoppingUserStatusBtn__1PCYN"};


//////////////////
// WEBPACK FOOTER
// ./routes/program-landing-page/components/startShoppingBtn/style.css
// module id = HoEk
// module chunks = 458